import React, { useEffect, useState } from 'react'
import { getDatabase, ref, onValue } from 'firebase/database'
import { Link } from 'react-router-dom'
import CopyButton from './components/CopyButton'
import Loader from './components/Loader'

const Tokens = ({ user }) => {
  const [tokens, setTokens] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const db = getDatabase()

    const tokensRef = ref(db, 'Tokens')
    const snapRef = onValue(tokensRef, (snapshot) => {
      const data = snapshot.val()
      setTokens(data)
      setLoading(false)
    })

    return () => {
      snapRef()
    }
  }, [user])

  if (loading) {
    return (
      <div className='flex justify-center py-16'>
        <Loader />
      </div>
    )
  }

  const tokenKeys = tokens ? Object.keys(tokens) : []

  if (tokenKeys.length === 0) {
    return (
      <div className='rounded-lg border border-gray-200 bg-white p-8 text-center text-sm text-gray-500 shadow-sm'>
        No tokens yet.
      </div>
    )
  }

  return (
    <div className='space-y-3'>
      {tokenKeys.map((key) => {
        const strDate = tokens[key].endDate
        const dArr = strDate.split('-')
        const formattedEndDate = `${dArr[1]}/${dArr[2]}/${dArr[0]}`
        return (
          <div
            key={key}
            className='rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition hover:border-blue-300 hover:shadow'
          >
            <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
              <Link to={`/tokens/${key}`} className='min-w-0'>
                <p className='truncate text-base font-semibold text-gray-900 hover:underline'>{tokens[key].name}</p>
                <p className='mt-0.5 text-sm text-gray-500'>Expires {formattedEndDate}</p>
              </Link>
              <div className='flex shrink-0 gap-2'>
                <CopyButton token={tokens[key].token} expireDate={formattedEndDate} template='email'>Copy Email</CopyButton>
                <CopyButton token={tokens[key].token} template='token'>Copy Token</CopyButton>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Tokens
